/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import {
  Button, Grid, Dialog, DialogTitle, DialogActions, DialogContent, TextField,
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import Select from 'react-select';
import Loading from '../../../components/loading/Loading';
import FlashContext from '../../../components/contexts/FlashContext';
import api from '../../../service/axios/api';

const selectStyles = {
  control: provided => ({ ...provided, height: 56, minHeight: 56 }),
  menu: provided => ({ ...provided, zIndex: 9999 }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
};

const typeOptions = [
  { value: 'Fixa', label: 'Fixa' },
  { value: 'Variável', label: 'Variável' },
];

export default function EditPaidBill({
  openEdit, setOpenEdit, loadingEdit, handleEdit,
  obs, setObs,
  type, setType,
  nfeNumber, setNfeNumber,
  dateIssue, setDateIssue,
  bankId, setBankId,
  realizedValue, setRealizedValue,
}) {
  const { notifyError } = useContext(FlashContext);
  const [bankList, setBankList] = useState([]);

  const getBanks = async () => {
    try {
      const data = await api.banks.get(false, 'Active');
      setBankList(data.retorno.map(i => ({ value: i.id, label: i.bank })));
    } catch (error) { notifyError(error.message); }
  };

  useEffect(() => {
    if (openEdit) {
      getBanks();
    }
  }, [openEdit]);

  return (
    <Dialog onClose={() => setOpenEdit(false)} open={openEdit} fullWidth maxWidth="sm">
      <Loading open={loadingEdit} msg="Salvando..." />
      <DialogTitle>Editar Conta Paga</DialogTitle>
      <DialogContent>
        <Grid container spacing={3} style={{ justifyContent: 'center' }}>

          {/* Tipo */}
          <Grid item sm={6} xs={12}>
            <Select
              value={typeOptions.find(opt => opt.value === type) || null}
              placeholder="Tipo (Fixa / Variável)"
              onChange={e => setType(e ? e.value : '')}
              options={typeOptions}
              styles={selectStyles}
            />
          </Grid>

          {/* Conta Bancária */}
          <Grid item sm={6} xs={12}>
            <Select
              value={bankList.find(opt => opt.value === bankId) || null}
              placeholder="Conta Bancária"
              onChange={e => setBankId(e ? e.value : null)}
              options={bankList}
              styles={selectStyles}
              isClearable
            />
          </Grid>

          {/* Valor Pago */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label="Valor Pago"
              variant="outlined"
              value={realizedValue}
              onChange={e => setRealizedValue(e.target.value)}
              placeholder="0,00"
            />
          </Grid>

          {/* Número NFe */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label="Número NFe"
              variant="outlined"
              value={nfeNumber}
              onChange={e => setNfeNumber(e.target.value)}
            />
          </Grid>

          {/* Data de Emissão */}
          <Grid item sm={6} xs={12}>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                label="Data de Emissão"
                variant="inline"
                inputVariant="outlined"
                style={{ backgroundColor: '#fff' }}
                size="medium"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={dateIssue}
                onChange={date => setDateIssue(date)}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          {/* Descrição/Observação */}
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              label="Descrição/Observação"
              variant="outlined"
              value={obs}
              onChange={e => setObs(e.target.value)}
              multiline
              rows={2}
              maxRows={10}
            />
          </Grid>

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button style={{ height: 40 }} onClick={() => setOpenEdit(false)} variant="text" color="primary">
          Cancelar
        </Button>
        <Button style={{ height: 40 }} onClick={handleEdit} disabled={loadingEdit} variant="contained" color="primary">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}